<template>
<div>
    <div v-if="ie=='i'">
        <!-- 斯里兰卡(LKA)进口提单明细 -->
        <el-card class="partItem">
            <table>
                <tbody>
                    <tr>
                        <th width="25%">进口商原始</th>
                        <td width="25%">{{billInfo.ImporterOriginalFormat}}</td>
                        <th width="25%">出口商原始</th>
                        <td width="25%">{{billInfo.ExporterOriginalFormat}}</td>
                    </tr>
                    <tr>
                        <th>出口国</th>
                        <td>{{billInfo.Country}}</td>
                        <th>数量单位</th>
                        <td>{{billInfo.Unit}}</td>
                    </tr>
                    <tr>
                        <th>毛重</th>
                        <td>{{billInfo.Weight}}</td>
                        <th>净重</th>
                        <td>{{billInfo.NetWeight}}</td>
                    </tr>
                    <tr>
                        <th>发票金额</th>
                        <td>{{billInfo.Value}} {{billInfo.ValueCurrency}}</td>
                        <th>外币总价</th>
                        <td>{{billInfo.ForeignValue ? billInfo.ForeignValue : 0}} {{billInfo.Currency}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>

        <el-card class="partItem">
            <div slot="header">
                <span class="headTitle">运输信息</span>
            </div>
            <table>
                <tbody>
                    <tr>
                        <th width="25%">运输方式</th>
                        <td width="25%">{{billInfo.DeliveryType}}</td>
                        <th width="25%">目的国</th>
                        <td width="25%">{{billInfo.DestinationCountry}}</td>
                    </tr>
                    <tr>
                        <th>装货港</th>
                        <td>{{billInfo.LoadingPort}}</td>
                        <th>船名</th>
                        <td>{{billInfo.VesselName}}</td>
                    </tr>
                    <tr>
                        <th>航程号码</th>
                        <td colspan="3">{{billInfo.VoyageNumber}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>
    </div>
    <div v-if="ie=='e'">
        <!-- 斯里兰卡(LKA)出口提单明细 -->
        <el-card class="partItem">
            <table>
                <tbody>
                    <tr>
                        <th width="25%">进口商原始</th>
                        <td width="25%">{{billInfo.ImporterOriginalFormat}}</td>
                        <th width="25%">出口商原始</th>
                        <td width="25%">{{billInfo.ExporterOriginalFormat}}</td>
                    </tr>
                    <tr>
                        <th>进口国</th>
                        <td>{{billInfo.Country}}</td>
                        <th>数量单位</th>
                        <td>{{billInfo.Unit}}</td>
                    </tr>
                    <tr>
                        <th>毛重</th>
                        <td>{{billInfo.Weight}}</td>
                        <th>净重</th>
                        <td>{{billInfo.NetWeight}}</td>
                    </tr>
                    <tr>
                        <th>发票金额</th>
                        <td>{{billInfo.Value}} {{billInfo.ValueCurrency}}</td>
                        <th>单价</th>
                        <td>{{billInfo.UnitPrise}}</td>
                    </tr>
                    <tr>
                        <th>外币总价</th>
                        <td colspan="3">{{billInfo.ForeignValue ? billInfo.ForeignValue : 0}} {{billInfo.Currency}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>

        <el-card class="partItem">
            <div slot="header">
                <span class="headTitle">运输信息</span>
            </div>
            <table>
                <tbody>
                    <tr>
                        <th width="25%">来源国</th>
                        <td width="25%">{{billInfo.OriginCountry}}</td>
                        <th width="25%">运输方式</th>
                        <td width="25%">{{billInfo.DeliveryType}}</td>
                    </tr>
                    <tr>
                        <th>船名</th>
                        <td>{{billInfo.VesselName}}</td>
                        <th>航程号码</th>
                        <td>{{billInfo.VoyageNumber}}</td>
                    </tr>
                    <tr>
                        <th>卸货港</th>
                        <td colspan="3">{{billInfo.unLoadingPort}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>
    </div>
</div>
</template>

<script>
export default {
    props:["billInfo","ie"],
    data() {
        return {

        };
    },
    methods: {
        
    },
    mounted() {

    },
};
</script>

<style lang="scss" scoped>
.partItem {
    margin-bottom: 20px;
    ::v-deep .el-card__header {
        padding: 10px 20px;
        .headTitle {
            display: inline-block;
            padding-left: 10px;
            font-size: 14px;
            border-left: 2px solid var(--themeColor);
            font-weight: bold;
        }
    }
}
table {
    width: 100%;
    border-collapse: collapse;
    tr {
        display: table-row;
        vertical-align: inherit;
        border-color: inherit;
        th,
        td {
            font-size: 12px;
            color: #666;
            height: 40px;
            border: 1px solid #eaeaea;
            text-align: center;
        }
        th {
            background-color: #f5f7fa;
            font-weight: 700;
        }
        .bg {
            background-color: var(--themeColor);
            color: #fff;
            font-weight: 700;
            opacity: 0.8;
        }
    }
}
</style>